module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "container container--fluid"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content xs12 md7",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('iframe', {
    staticClass: "profile-iframe",
    attrs: {
      "src": _vm.formUrl,
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "title": "Travel"
    }
  })])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10a04ce1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/ProfileTally/Form.vue
// module id = 2007
// module chunks = 0